module.exports = __webpack_public_path__ + "img/Loader.b54f65a3.gif";